import { Component,OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { PatientServiceService } from '../../services/PatientService.service';
import { PatientData } from '../../models/PatientData.model';
import { interval } from 'rxjs';
import { Noti } from '../../../SuperAdmin/models/Notification.model';
import { NgForm } from '@angular/forms';
import { WebUserDetails } from '../../../../shared/models/WebUserDetails';
import { WebUserService } from '../../../../core/services/WebUser.service';
import { AlertMessages, AlertType } from '../../../../core/AlertMessages';

@Component({
  selector: 'PAapp-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})

export class PaHeaderComponent implements OnInit {
  htmlView: boolean= true;
  errHeader: string;
  errMessage: string[]= [];
  patientProfileData: PatientData;
  notifications: Noti[];
  notCount: number;
  showAlert: boolean;
  showSession: boolean = false;
  toggleSlide: boolean;
  elementHeader: HTMLElement;
  elementComplete: HTMLElement;
  sliderText: string;
  showToogleImage: boolean = false;
  allUsers: WebUserDetails[];
  oldPwd: string;
  newPwd: string;
  rePwd: string;
  constructor(private router: Router, private _service: PatientServiceService, private webser: WebUserService) {
    this.allUsers = JSON.parse(localStorage.getItem('userDetails'));
  }

  ngOnInit() {
    this.toggleSlide = true;
    this.sliderText = "large";
    if (this._service.subsVar == undefined) {
      this._service.subsVar = this._service.
      invokeFirstComponentFunction.subscribe((name: string) => {
        this.getPatientData();
      });
    }
    if (this._service.contentHeight == undefined) {
      this._service.contentHeight = this._service.
      invokeAutoAdjust.subscribe((name: string) => {
        this.autoAdjustHeight();
      });
    }
    this.getPatientData();
    this.getNotifications();
  }

  autoAdjustHeight() {

    this.sliderText == "small" ? this.adjustHeight('87vh') : this.adjustHeight('74vh');
  }

  alertClose() {
    setTimeout(() => {
      this.showAlert = false;
    }, 3000);
  }

  clearData(form: NgForm) {
    form.reset();
  }

  continueSession() {
    this.showSession = false;
  }

  public HandleUserInactivity() {
    this.showSession = true;
  }

  deleteNot() {
    let delNots = [];
    let newNots = this.notifications.filter(i => i.isNew == true);

    newNots.forEach((i) => {
      delNots.push(i.id);
    });

    if (delNots.length > 0) {
      this._service.removeNotification(delNots).subscribe((data) => {
        this.notCount = 0;
      });
    }
  }

  getNotifications() {
    this._service.getNotification().subscribe((x) => {
      this.notifications = x as Noti[];
      this.notifications.forEach(element => {
        var date = new Date(element.notifyDate);
        element.notDate = date.getDate() + "-" + (1 + date.getMonth()) + "-" + date.getFullYear() + " " + date.getHours() + ":" + date.getMinutes() + ":" + date.getSeconds();
      })
      this.notCount = this.notifications.filter(i => i.isNew == true).length;
    })
  }

  getPatientData() {
    this._service.getPatientProfileData().subscribe((data) => {
      this.patientProfileData = data as PatientData;
      this.patientProfileData.dobDate = new Date(this.patientProfileData.DobDate);
    }, err => {
      if (err.status === 400) {
       this.errHeader = 'Server Exception';
       this.errMessage = err.error;
       this.htmlView = false;
      }
    }, () => { this.htmlView = true; });
  }

  logout() {
    this.allUsers = JSON.parse(localStorage.getItem('userDetails'));
    this.allUsers.splice(this.allUsers.findIndex(i => i.id == JSON.parse(sessionStorage.getItem('Id'))), 1);
    localStorage.setItem('userDetails', JSON.stringify(this.allUsers));
    sessionStorage.clear();
    this.showSession = false;
    this.router.navigate(['/login']);
  }

  onSubmit(form: NgForm) {

    this._service.changePassword(form.value.oldPwd, form.value.newPwd, form.value.rePwd).subscribe((data) => {
      if (data["Id"] == 1) {
        this.alertClose();
        AlertMessages.Show("Alert", data["StatusMessage"], AlertType.Success);
        form.reset();
      } else {
        this.alertClose();
        AlertMessages.Show("Alert", data["StatusMessage"], AlertType.Error);
        form.reset();
      }
    });
  }


  toggleHeader(imageStatus:boolean,text:string,displayValue:string,height:string) {
    this.showToogleImage = imageStatus;
    this.toggleSlide = !this.toggleSlide;
    this.sliderText = text;
    this.elementHeader = document.getElementById("headerContentt") as HTMLElement;
    this.elementHeader.style.display = displayValue;
    this.adjustHeight(height);
  }

  adjustHeight(height) {
    this.elementComplete = document.getElementById("PAmain") as HTMLElement;
    if (this.elementComplete != undefined || this.elementComplete != null) {
      this.elementComplete.style.height = height;
    }
  }

}
